import EstoqueMoviOperacaoService from "@/services/EstoqueMoviOperacaoService";

export const estoqueMoviOperacao = {
  namespaced: true,
  state: {
    estoqueMoviOperacao: {},
  },
  actions: {
    getEstoqueMoviOperacao({ commit }, payload) {
      return EstoqueMoviOperacaoService.GetEstoqueMoviOperacao(payload).then(
        (estoqueMoviOperacao) => {
          return Promise.resolve(estoqueMoviOperacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEstoqueMoviOperacao({ commit }, payload) {
      return EstoqueMoviOperacaoService.PostEstoqueMoviOperacao(payload).then(
        (estoqueMoviOperacao) => {
          return Promise.resolve(estoqueMoviOperacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEstoqueMoviOperacao({ commit }, payload) {
      return EstoqueMoviOperacaoService.PutEstoqueMoviOperacao(payload).then(
        (estoqueMoviOperacao) => {
          return Promise.resolve(estoqueMoviOperacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEstoqueMoviOperacao({ commit }, payload) {
      return EstoqueMoviOperacaoService.DeleteEstoqueMoviOperacao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEstoqueMoviOperacaoOData({ commit }, payload) {
      return EstoqueMoviOperacaoService.GetEstoqueMoviOperacaoOData(
        payload
      ).then(
        (estoqueMoviOperacao) => {
          return Promise.resolve(estoqueMoviOperacao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default estoqueMoviOperacao;
